import { render, staticRenderFns } from "./actividad-actividad-ars.vue?vue&type=template&id=41df3d58&"
import script from "./actividad-actividad-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-actividad-ars.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports